module.exports = __webpack_public_path__ + "img/7.c3d6274a.jpg";